<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          v-if="dialog.form"
          :fullscreen="dialog.fullscreen"
          width="800"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Detail Pemakaian / Penggunaan
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 mb-4 mt-1">
              <div v-if="!process.detail && selected.detail.length > 0">
                <table>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Nama Fasilitas Umum
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : {{ selected.detail[0].product_name }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Nama Pelanggan
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : {{ selected.detail[0].customer_name }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Telepon Pelanggan
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : {{ selected.detail[0].customer_mobilephone }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Email Pelanggan
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : {{ selected.detail[0].customer_email }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Alamat Pelanggan
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : {{ selected.detail[0].customer_address }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Tanggal Booking
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : {{ selected.detail[0].event_start_date | date }} - {{ selected.detail[0].event_end_date | date }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Nama Event
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : {{ selected.detail[0].event_name }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Deskripsi Event
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : {{ selected.detail[0].event_description }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Status
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5 text-capitalize">
                      : {{ selected.detail[0].status }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Id Billing
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : {{ selected.detail[0].status === 'diterima' ? selected.detail[0].id_billing : '-' }}
                    </td>
                  </tr>
                  <tr v-if="selected.detail[0].status === 'diterima' && selected.detail[0].payment_status === 'belum lunas'">
                    <td class="fs-14 font-weight-light black--text py-1">
                      Download STS
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5 d-flex">
                      : <div v-if="selected.detail[0].id_billing !== ''">
                        <v-btn
                          rounded
                          small
                          :loading="process.export"
                          :disabled="process.export"
                          width="120"
                          color="primary"
                          @click="exports(selected.detail[0].id)"
                          elevation="0"
                          class="body-2 font-weight-bold text-capitalize white--text ml-1">
                          Download
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="selected.detail[0].status === 'diterima' && selected.detail[0].payment_status === 'lunas'">
                    <td class="fs-14 font-weight-light black--text py-1">
                      Download STTS
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5 d-flex">
                      : <div>
                        <v-btn
                          rounded
                          small
                          :loading="process.export"
                          :disabled="process.export"
                          width="120"
                          color="primary"
                          @click="exportsStts(selected.detail[0].id)"
                          elevation="0"
                          class="body-2 font-weight-bold text-capitalize white--text ml-1">
                          Download
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Status Pembayaran
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5 text-capitalize">
                      : {{ selected.detail[0].payment_status }}
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Tanggal Pembayaran
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5">
                      : 
                      <span v-if="selected.detail[0].payment_datetime !== ''" class="black--text">
                        {{ selected.detail[0].payment_datetime | datetime }}
                      </span>
                      <span v-if="selected.detail[0].payment_datetime === ''">
                        -
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="fs-14 font-weight-light black--text py-1">
                      Link Detail Pemakaian / Penggunaan
                    </td>
                    <td class="fs-14 font-weight-light black--text py-1 px-5 text-capitalize">
                      : <a :href="`https://sifasum.klaten.go.id//order/${selected.detail[0].uuid}`" target="_blank" class="text-decoration-none">Klik Disini</a>
                    </td>
                  </tr>
                </table>

                <div v-if="qr_code !== '' && selected.detail[0].id_billing !== '' && selected.detail[0].status === 'diterima' && selected.detail[0].payment_status === 'belum lunas'" class="mt-2 bg-white border border-gray-200 rounded-lg overflow-hidden" style="width: 450px;">
                  <div class="fs-14 black--text mb-2">
                    QR Code
                  </div>
                  <!-- Header -->
                  <div class="bg-white p-4 border-b border-gray-100">
                    <img 
                      src="https://cdn-1.klaten.go.id/sifasum/image/20250826211158-1756242718.jpg"
                      alt="QRIS Header" 
                      class="w-full h-auto"
                      style="max-height: 120px; object-fit: cover;"
                    />
                  </div>
                  
                  <!-- QR Code Image -->
                  <div class="p-6 text-center">
                    <img 
                      :src="qr_code" 
                      alt="QRIS Code" 
                      class="mx-auto"
                      style="max-width: 200px; height: auto;"
                    />
                  </div>
                  
                  <!-- Transaction Info -->
                  <div class="px-6 pb-4 text-center">
                    <!-- <div class="text-gray-700 text-sm mb-1">RETRI:PENDPTN-RETRIBUSI KAB. KLATEN</div> -->
                    <div class="text-gray-800 font-semibold mb-1">{{ selected.detail[0].customer_name || 'Customer Name' }}</div>
                    <div class="text-green-600 font-bold text-lg">{{ selected.detail[0].total | price }}</div>
                  </div>
                  
                  <!-- Footer Download Button -->
                  <div class="pa-3 text-center" :style="{ backgroundColor: set_color }">
                    <a :href="qr_code" target="_blank" class="text-decoration-none white--text">
                      <div class="flex items-center justify-center text-white">
                        <v-icon class="mr-2" color="white" size="small">mdi-download</v-icon>
                        <span class="font-semibold">Download</span>
                      </div>
                    </a>
                  </div>
                </div>

                <div v-if="process.create_qr">
                  <div class="text-center py-4" style="height: 200px; display: flex; align-items: center; justify-content: center; width: 450px;">
                    Memuat QR Code . . .
                  </div>
                </div>

                <div style="border: 1px solid #e0e0e0; border-radius: 6px; padding: 10px;" class="mt-4">
                  <div class="fs-14 font_weight_600 black--text mb-2">
                    Detail Nominal
                  </div>
                  <v-divider 
                    class="mb-2"
                    style="border-top: 1px solid #e0e0e0;"/>
                  <table style="border: none; width: 100%; border-collapse: collapse;">
                    <tr v-for="(item, index) in selected.detail[0].so_detail" :key="index">
                      <td style="font-size: 12px; z-index: 1; color: white; border-left: none; padding: 8px 0px; text-align: left;" class="black--text">
                        <div class="d-flex justify-space-between">
                          <div>
                            {{ item.date | dateFull }}
                          </div>
                          <div>
                            {{ item.price_value | price }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <v-divider 
                    class="mt-2"
                    style="border-top: 1px solid #e0e0e0;"/>
                  <div class="d-flex fs-14 align-center justify-space-between font-weight-bold black--text mt-3">
                    <div>
                      Total
                    </div>
                    <div>
                      {{ selected.detail[0].total | price }}
                    </div>
                  </div>
                </div>

                <v-row>
                  <v-col cols="12" md="5">
                    <div class="mt-4 mb-2">
                      Photo KTP
                    </div>
                    <v-card flat style="border-radius: 6px; border: 1px solid #E7E7E7;">
                      <v-img
                        contain
                        :src="selected.detail[0].nik_url"
                        :alt="selected.detail[0].product_name"
                        :height="250"
                        width="100%">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>  
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="7" v-if="selected.detail[0].proposal_url !== ''">
                    <div class="mt-4 mb-2">
                      File Proposal/Permohonan
                    </div>
                    <v-card flat style="border-radius: 6px; border: 1px solid #E7E7E7;">
                      <v-img
                        v-if="selected.detail[0].proposal_url.split('.').pop() !== 'pdf'"
                        contain
                        :src="selected.detail[0].proposal_url"
                        :alt="selected.detail[0].product_name"
                        :height="250"
                        width="100%">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>  
                      <div v-if="selected.detail[0].proposal_url.split('.').pop() === 'pdf'">
                        <iframe :src="selected.detail[0].proposal_url" height="250" width="100%" frameborder="0"></iframe>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div v-if="process.detail">
                <div class="pb-0 my-4" 
                  style="height: 300px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>
  
                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-btn
                rounded
                width="120"
                color="primary"
                @click="dialog.update = true;"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ubah Data
              </v-btn>

              <v-spacer/>

              <v-btn
                rounded
                v-if="selected.detail[0].status === 'dalam proses' || selected.detail[0].status === 'ditolak'"
                width="120"
                @click="dialog.approval = true; process.approval = false; selected.approval[0] = { status: 'diterima', description: '' }"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Terima
              </v-btn>
              <v-btn
                rounded
                v-if="selected.detail[0].status === 'dalam proses'"
                width="120"
                @click="dialog.approval = true; process.approval = false; selected.approval[0] = { status: 'ditolak', description: '' };"
                color="red"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Tolak
              </v-btn>
              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.approval"
          @keydown.esc="dialog.approval = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          v-if="dialog.approval"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Konfirmasi {{ selected.approval[0].status === 'diterima' ? 'Diterima' : 'Ditolak' }}

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.approval = false; dialog.fullscreen = false; selected.approval = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin untuk {{ selected.approval[0].status === 'diterima' ? 'menerima' : 'menolak' }} data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?

              <div class="mt-5">
                <v-textarea
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Deskripsi"

                  hide-details

                  v-model="selected.approval[0].description"
                  style="border-radius: 10px;">
                </v-textarea>
              </div>
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="approvals()"
                :loading="process.approval"
                :disabled="process.approval"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Yakin
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.approval = false; dialog.fullscreen = false; selected.approval = [];"
                :disabled="process.approval"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div v-if="dialog.update">
          <UpdatOrder 
            :products="product" 
            :dialog="dialog.update" 
            :order="selected.detail[0]" 
            @close="dialog.update = false;"
            @update="fetch(); fetchDetailOrder(selected.detail[0].id)" />
        </div>

        
        <section>
          <v-row
            class="pa-4 pb-0 pt-0">
            <v-col
              cols="12" class="pb-1">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="22">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="fs-16 black--text ml-2"
                      style="font-weight: 600;">
                      Daftar Pemakaian / Penggunaan
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="start"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="12"
              class="d-flex align-center pb-1">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                class="fs-12 little-placeholder"
                style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
              </v-text-field>
              <div class="ml-2">
                <v-text-field
                  @click:clear="filter.date = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line
                  type="date"

                  hide-details
                  :color="set_color"
                  placeholder="Cari Tanggal"
                  clearable

                  v-model="filter.date"
                  class="fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px">
                </v-text-field>
              </div>
              <div class="ml-2">
                <v-autocomplete
                  @click:clear="filter.status = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line
                  :items="status"
                  item-text="text"
                  item-value="value"
                  v-on:change="fetch()"

                  hide-details
                  :color="set_color"
                  placeholder="Pilih Status"
                  clearable

                  v-model="filter.status"
                  class="fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px">
                </v-autocomplete>
              </div>
              <div class="ml-2">
                <v-autocomplete
                  @click:clear="filter.product_id = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line
                  :items="product"
                  item-text="name"
                  item-value="id"
                  v-on:change="fetch()"

                  hide-details
                  :color="set_color"
                  placeholder="Pilih Fasilitas Umum"
                  clearable

                  v-model="filter.product_id"
                  class="fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px">
                </v-autocomplete>
              </div>
              <div class="ml-2">
                <v-autocomplete
                  @click:clear="filter.status_payment = ''; fetch();"
                  v-on:keyup.enter="fetch()"

                  filled
                  rounded
                  dense
                  single-line
                  :items="[
                    { id: 'lunas', name: 'Lunas' },
                    { id: 'belum_lunas', name: 'Belum Lunas' }
                  ]"
                  item-text="name"
                  item-value="id"
                  v-on:change="fetch()"

                  hide-details
                  :color="set_color"
                  placeholder="Pilih Status Pembayaran"
                  clearable

                  v-model="filter.status_payment"
                  class="fs-12 little-placeholder"
                  style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 200px">
                </v-autocomplete>
              </div>
              <div class="ml-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="exports_excel()"
                      :loading="process.export_excel"
                      elevation="0"
                      dark
                      min-height="28"
                      small
                      min-width="28"
                      color="#097640"
                      class="text-capitalize px-0 white--text"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on">
                      <v-icon size="18">mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export Excel</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <div class="view">
                  <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper-pegawai'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th :style="`background-color: ${set_color}; color: #fff;`" class="sticky-col one-col" style="z-index: 1;  color: white; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'input_datetime' ? toSort('input_datetime') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Tanggal Input
                          <span v-if="sortBy === 'input_datetime'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Batas Waktu Verifikasi
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Deadline Pembayaran
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'event_start_date' ? toSort('event_start_date') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Tanggal Booking
                          <span v-if="sortBy === 'event_start_date'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'product_name' ? toSort('product_name') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Nama Fasilitas Umum
                          <span v-if="sortBy === 'product_name'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'customer_name' ? toSort('customer_name') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Nama Pelanggan
                          <span v-if="sortBy === 'customer_name'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'customer_mobilephone' ? toSort('customer_mobilephone') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Telepon Pelanggan
                          <span v-if="sortBy === 'customer_mobilephone'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'customer_email' ? toSort('customer_email') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Email Pelanggan
                          <span v-if="sortBy === 'customer_email'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'event_name' ? toSort('event_name') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Nama Event
                          <span v-if="sortBy === 'event_name'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'total' ? toSort('total') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Total Pembayaran
                          <span v-if="sortBy === 'total'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'status' ? toSort('status') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Status
                          <span v-if="sortBy === 'status'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>

                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'payment_status' ? toSort('payment_status') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Status Pembayaran
                          <span v-if="sortBy === 'payment_status'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                        <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 2px; text-align: center;" :style="getCellStyle(item)">
                          <!-- <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                
                                v-bind="attrs"
                                v-on="on"

                                min-width="25"
                                height="25"
                                x-small
                                @click="dialog.form = true; reset(index);"
                                rounded
                                color="blue"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-square-edit-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Ubah</span>
                          </v-tooltip>

                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="toDelete(item.id)"

                                v-bind="attrs"
                                v-on="on"

                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="red"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </template>
                            
                            <span>Hapus</span>
                          </v-tooltip> -->
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                
                                v-bind="attrs"
                                v-on="on"
                                @click="dialog.form = true; fetchDetailOrder(item.id); process.create_qr = false; qr_code = '';"

                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="green"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-information-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Detail</span>
                          </v-tooltip>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.input_datetime | date }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <div v-if="item.status === 'dalam proses'">
                            {{ getSisaHari(item.expired_verifikasi_date) }} Hari
                          </div>
                          <div v-else>
                            -
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <div v-if="item.status === 'diterima' && item.payment_status === 'belum lunas'">
                            {{ item.days }} hari {{ item.hours }} jam {{ item.minutes }} menit {{ item.seconds }} detik
                          </div>
                          <div v-else>
                            -
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">
                          <div v-if="item.event_start_date === item.event_end_date">
                            {{ item.event_start_date | date }}
                          </div>
                          <div v-else>
                            {{ item.event_start_date | date }} - {{ item.event_end_date | date }}
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.product_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.customer_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.customer_mobilephone }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.customer_email }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.event_name }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)">{{ item.total | price }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)" class="text-capitalize">{{ item.status }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 100%; padding: 8px 12px; text-align: left;" :style="getCellStyle(item)" class="text-capitalize">{{ item.payment_status }}</td>
                        
                      </tr>
                    </table>
                  </div>
    
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
    
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
    
                  <v-card-text
                    v-if="!process.load && list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>
    
                  <pagination v-if="!process.load && pagination.total_data > 0"
                    @changePage="fetch($event)" 
                    @reloadPage="fetch($event)" 
                    :model="pagination" :display="paginationList"/>
    
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false,
          approval: false,
          update: false,
        },
        
        search: '',

        filter: {
          date: '',
          product_id: '',
          status: 'dalam proses',
          status_payment: ''
        },

        upload: {
          folder: null
        },
        

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          detail: [],
          approval: []
        },

        paginationList: {
          row: 20,
          page: 1
        },

        role: [],
        sortBy: 'id',
        sortDesc: '-',

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          date: '',
          description: ''
        },

        product: [],
        status: [
          {
            text: 'Dalam Proses',
            value: 'dalam proses'
          },
          {
            text: 'Diterima',
            value: 'diterima'
          },
          {
            text: 'Ditolak',
            value: 'ditolak'
          },
          {
            text: 'Expired',
            value: 'expired'
          }
        ],

        qr_code: '',

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          export: false,
          form: false,
          file: false,
          approval: false,
          detail: false,
          export_excel: false,
          create_qr: false,
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
      UpdatOrder: () => import(/* webpackPrefetch: true */ '@/components/order/update-order.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }

      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.image_url = this.upload.folder.data.full.file_url
              this.form.image_url = this.upload.folder.fileuri
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
    mounted () {
      this.fetch()
      this.fetchProduct()
    },
    methods: {
      getCellStyle(item) {
        // Jika diterima, belum lunas, dan waktu tersisa < 6 jam
        const totalHoursLeft = item.days * 24 + item.hours;
        const isWarning = item.status === 'diterima' &&
                          item.payment_status === 'belum lunas' &&
                          totalHoursLeft < 6;

        if (isWarning) {
          return 'background-color: #ffb3b3'; // merah muda
        }

        // Default: jika status 'dalam proses' dan sisa hari = 1
        if (this.getSisaHari(item.expired_verifikasi_date) === '1' &&
            item.status === 'dalam proses') {
          return 'background-color: #ffdede';
        }

        return 'background-color: white';
      },

      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },

      getSisaHari(date) {
        // if (!date || !moment(date).isValid()) return '0';
        
        // const now = moment();
        // const target = moment(date);

        // const diff = target.diff(now, 'days');

        if (!date || !moment(date).isValid()) return '0';

        const now = moment();
        const target = moment(date);

        const diffMs = target.diff(now);
        const diff = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        
        if (isNaN(diff)) return '0';
        return diff < 0 ? '0' : `${diff}`;
      },


      async fetchProduct () {
        let params = {
          limit: 1000000
        }
        await get(`admin/product/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.product = res.results.data
          }
        })
      },

      async fetchDetail () {
        let params = {
          limit: 1000000
        }
        await get(`admin/product/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.product = res.results.data
          }
        })
      },

      async fetchDetailOrder (id) {
        this.process.detail = true
        let params = {
          id: id
        }
        await get(`admin/order/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.detail = false
            
          if (res.status === 200) {
            let data = []
            res.results.data.so_detail.map(detail => {
              data.push({
                ...detail,
                price: detail.price_value
              })
            })
            this.selected.detail[0] = res.results.data
            this.selected.detail[0].so_detail = data

            this.fetchDetailOrderPayment(id)

            if (this.selected.detail[0].id_billing !== '' && this.selected.detail[0].status === 'diterima' && this.selected.detail[0].payment_status === 'belum lunas') {
              this.CreateQr()
            }
          }
        })
      },

      async fetchDetailOrderPayment (id) {
        // this.process.detail = true
        let params = {
          so_id: id
        }
        await get(`admin/order/check_status`, { params })
        .then(response => {
          let res = response.data

          this.process.detail = false
            
          if (res.status === 200) {
            this.selected.detail[0].payment_status = res.results.data.payment_status
            this.selected.detail[0].payment_datetime = res.results.data.payment_datetime
          }
        })
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          status: this.filter.status,
          product_id: this.filter.product_id,
          payment_status: this.filter.status_payment,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get(`admin/order/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '150px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              // {
              //   text: 'Status',
              //   width: '100px',
              //   value: 'is_active',
              //   freeze: false,
              //   hide: false,
              //   align: 'center',
              //   format: 'bool'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama Lengkap',
                width: '300px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Kategori Pegawai',
                width: '200px',
                value: 'cat_title',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '200px',
                value: 'email',
                freeze: false,
                hide: false
              },
              {
                text: 'Telepon',
                width: '200px',
                value: 'mobilephone',
                freeze: false,
                hide: false
              },
              // {
              //   text: 'Jenis Kelamin',
              //   width: '200px',
              //   value: 'gender',
              //   freeze: false,
              //   hide: false
              // },
              // {
              //   text: 'Nama Outlet',
              //   width: '400px',
              //   value: 'outlet_name',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Dibuat Tanggal',
                width: '100%',
                value: 'input_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              }
            ]

            this.list = []
            this.pagination = res.results.pagination

            this.list = res.results.data.map(item => ({
              ...item,
              billing_expired_datetime: new Date(item.billing_expired_datetime),
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
            }));

            this.list.map(obj => {
              obj.is_active = obj.is_active === '1' ? true : false
            })

            this.updateCountdowns();
            this.intervalId = setInterval(this.updateCountdowns, 1000);


            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            // this.addFreezes()

            if (this.$refs['table-grid'] && this.$refs['table-grid'].$el) {
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
            }

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      updateCountdowns() {
        const now = new Date();

        this.list.forEach(item => {
          const diff = item.billing_expired_datetime - now;

          if (diff <= 0) {
            item.days = item.hours = item.minutes = item.seconds = 0;
            return;
          }

          const totalSeconds = Math.floor(diff / 1000);
          item.days = Math.floor(totalSeconds / (60 * 60 * 24));
          item.hours = Math.floor((totalSeconds % (60 * 60 * 24)) / 3600);
          item.minutes = Math.floor((totalSeconds % 3600) / 60);
          item.seconds = totalSeconds % 60;
        });
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          date: index !== undefined ? this.list[index].date : '',
          description: index !== undefined ? this.list[index].description : ''
        }

        this.process.form = false

        this.message.error = ''

        // if (this.dialog.form) 
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          // if (this.form.id === '') {
          //   this.list.push(
          //     {
          //       id: this.list.length,
          //       title: this.form.title,
          //       date: this.form.date,
          //       end_date: this.form.end_date,
          //       start_time: this.form.start_time,
          //       end_time: this.form.end_time,
          //       desc: this.form.desc,
          //       image_url: this.form.image_url
          //     }
          //   )
          // } else {
          //   this.list[this.form.id] = {
          //     id: this.form.id,
          //     title: this.form.title,
          //     date: this.form.date,
          //     end_date: this.form.end_date,
          //     start_time: this.form.start_time,
          //     end_time: this.form.end_time,
          //     desc: this.form.desc,
          //     image_url: this.form.image_url
          //   }
          // }
          // this.dialog.form = false

          // this.dialog.snackbar = true
          // this.message.success = this.form.id === '' ? 'Berhasil Menambah Agenda' : 'Berhasil Mengubah Agenda'

          // this.dialog.fullscreen = false

          // this.reset()

          // this.fetch()

          let url = this.form.id === '' ? 'admin/order/add' : 'admin/order/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            if (errors.length > 0 && this.$refs.form.refs[errors[0]['key']] && this.$refs.form.refs[errors[0]['key']].$el) {
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }
          }, 10)
        }
      },
      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/order/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },
      async approvals () {
        this.message.error = ''

        this.process.approval = true

        await post(`admin/order/approval`, {
          data: {
            id: this.selected.detail[0].id,
            status: this.selected.approval[0].status,
            description: this.selected.approval[0].description
          }
        }).then(response => {
          let res = response.data

          this.process.approval = false

          if (res.status === 200) {

            this.dialog.approval = false
            this.dialog.form = false

            this.selected.row = []
            this.selected.approval = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      async CreateQr () {
        this.message.error = ''

        this.process.create_qr = true

        try {
          const response = await post(`sites/order/create_qr`, {
            data: {
              id_billing: `73${this.selected.detail[0].id_billing}`
            }
          })
          
          let res = response.data

          // console.log(res)

          if (res.status === 200) {

            // Fetch HTML dari URL QRIS
            const htmlResponse = await fetch(res.results.data.data)
            const htmlText = await htmlResponse.text()
            
            // console.log('HTML Response:', htmlText.substring(0, 500)) // Log first 500 chars
            
            // Parse HTML untuk mendapatkan gambar QRIS
            const parser = new DOMParser()
            const doc = parser.parseFromString(htmlText, 'text/html')
            const imgElement = doc.querySelector('#qrResults')

            // console.log('imgElement:', imgElement)
            // console.log('qrisUrl:', qrisUrl)
            
            if (imgElement && imgElement.src) {
              this.qr_code = imgElement.src
              // loadingQris.value = false
              // console.log('QRIS image URL:', qris.value)
            } else {
              console.error('QRIS image not found in HTML')
              // Coba cari elemen img lain
              const allImages = doc.querySelectorAll('img')
              // console.log('All images found:', allImages)
              // Jika tidak ada #qrResults, coba gunakan gambar pertama
              if (allImages.length > 0 && allImages[0].src) {
                this.qr_code = allImages[0].src
                // console.log('Using first image:', qris.value)
              }
            }

          this.process.create_qr = false

            // this.dialog.approval = false
            // this.dialog.form = false

            // this.selected.row = []
            // this.selected.approval = []
            
            // this.dialog.snackbar = true
            // this.message.success = res.message

            // this.dialog.fullscreen = false

            // this.fetch()
          } else {
            this.message.error = res.message
          }
        } catch (error) {
          this.process.create_qr = false
          this.message.error = error.message || 'Terjadi kesalahan saat membuat QR'
        }
      },
      // EXPORT
      async exports (id) {
        this.message.error = ''

        this.process.export = true

        let params = {
          id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/admin/order/export_pdf_sts`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response
          // console.log(res)

          this.process.export = false
          let disposition = res.headers['content-disposition']
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          let filename = ''
          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },

      async exportsStts (id) {
        this.message.error = ''

        this.process.export = true

        let params = {
          id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/admin/order/export_pdf_stts`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response
          // console.log(res)

          this.process.export = false
          let disposition = res.headers['content-disposition']
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          let filename = ''
          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },

      async exports_excel () {
        this.message.error = ''

        this.process.export_excel = true

        let params = {
          limit: this.paginationList.row,
          page: this.paginationList.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          status: this.filter.status,
          product_id: this.filter.product_id,
          payment_status: this.filter.status_payment,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/order/export_excel`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export_excel = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          // let filename = ''

          // if (disposition && disposition.indexOf('inline') !== -1) {
          //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          //   var matches = filenameRegex.exec(disposition);
          //   if (matches != null && matches[1]) { 
          //     filename = matches[1].replace(/['"]/g, '');
          //   }
          // }
          console.log(fileName)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  /* width: 100%; */
}

.wrapper-pegawai { 
  overflow-y: auto; 
  height: calc(100vh - 265px); 
} 

.wrapper-pegawai-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
} 

.wrapper-pegawai th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  /* background-color: #080679 !important; */
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>